import { Box, Stack, Text } from "@mantine/core";
import RecentLeadsListQuery from "./RecentLeadsListQuery";
import RecentLeadItem from "./RecentLeadItem";
import classes from "../..//Home.module.css";
import { useTranslation } from "react-i18next";

export default function RecentLeadsList() {
  const { t } = useTranslation("features");

  const { recentLeads } = RecentLeadsListQuery();

  if (recentLeads.length == 0) {
    return (
      <Box className={classes.listContainer}>
        <Box className={classes.noListItem}>
          <Text w={"100%"} className={classes.listNoItemsText}>
            {t(`home.noRecentLeads`)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Stack className={classes.listContainer} gap={8}>
      {recentLeads.map((lead, index) => {
        return <RecentLeadItem key={index} lead={lead} />;
      })}
    </Stack>
  );
}
